@if (projectId) {
  <button
    mat-icon-button
    [matTooltip]="isWatching() ? 'Unwatch project' : 'Watch project'"
    (click)="toggleWatch()"
    [class.watching]="isWatching()"
    class="watch-toggle"
  >
    <mat-icon>{{ isWatching() ? "visibility" : "visibility_off" }}</mat-icon>
  </button>
}
